module.exports = __webpack_public_path__ + "static/img/invest-health7.05a6006.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-health7.jpg
// module id = mmK5
// module chunks = 0